export default "__VITE_ASSET__868e9b44__"